// Data categories based on Sector field from JSON data files
// Order matches OLD TRAC site for familiarity (AMENITIES → Education → Health → WASH → Energy → Gender → Livelihoods → People → Nutrition → Climate)

export const dataCategories = [
  {
    id: "amenities",
    name: "Amenities",
    icon: "🏠",
    color: "bg-purple-500",
    description: "Household amenities and infrastructure",
    indicators: [
      "Household with 6-8 members (%)",
      "Household with five members (%)",
      "Household with four members (%)",
      "Household with nine and above members (%)",
      "Household with one member (%)",
      "Household with three members (%)",
      "Household with two members (%)",
      "Households availing banking services (%)",
      "Households having  TV, Computer/Laptop, Telephone/mobile phone and Scooter/ Car (%)",
      "Households having  internet facility (%)",
      "Households having Bicycle (%)",
      "Households having Car/ Jeep/Van (%)",
      "Households having Radio/Transistor (%)",
      "Households having Scooter/ Motorcycle/Moped (%)",
      "Households having Television (%)",
      "Households having a mobile phone (%)",
      "Households which Does not have kitchen (%)",
      "Households which has Kitchen (%)",
      "Households with Cooking facilities outside house (%)",
      "Households with Cooking facility inside house (%)",
      "Households with Permanent structure of census houses (%)",
      "Households with Semi-Permanent structure of census houses (%)",
      "Households with five dwelling rooms (%)",
      "Households with four dwelling rooms (%)",
      "Households with one dwelling rooms (%)",
      "Households with six and above dwelling rooms (%)",
      "Households with three dwelling rooms (%)",
      "Households with two dwelling rooms (%)",
      "Households without radio, TV, Internet,Landline, mobile, bicycle, scooter, car/jeep/van (%)",
      "Proportion of owned households",
      "Proportion of rented households",
      "Total Residence houses in Dilapidated condition (%)",
      "Total Residence houses in Good condition (%)",
      "Total Residence houses in Livable condition (%)",
    ],
  },
  {
    id: "education",
    name: "Education",
    icon: "📚",
    color: "bg-green-500",
    description: "Educational attainment and literacy",
    indicators: [
      "Average number of Teacher per School",
      "Children aged 3-6 years currently attending pre-school education (PSE) at Anganwadi centre (%)",
      "Children aged 3-6 years currently attending pre-school education (PSE) at Privately run institution (Play school, nursery etc.) (%)",
      "Children aged 3-6 years currently not attending PSE (%)",
      "Children attended before / Drop out (Age 6-17 years) (%)-Person",
      "Children currently attending school (Age 6-17 years) (%)-Person",
      "Children who can do division (%)",
      "Children who can do substraction (%)",
      "Children who can not read any letter (%)",
      "Children who can read English easy sentences (%)",
      "Dropout Rate - Grade 1",
      "Dropout Rate - Grade 1  to 5",
      "Dropout Rate - Grade 5",
      "Dropout Rate - Grade 6 to 8",
      "Dropout Rate - Grade 8",
      "Enrolment at Government Schools",
      "Enrolment at private Schools",
      "Female Literacy Rate",
      "Gross Enrolment Ratio at Primary Level",
      "Gross Enrolment Ratio at Upper Primary Level",
      "Literacy Rate 7 Year & above",
      "Male Literacy Rate",
      "Men who are literate (%)",
      "Net Enrolment Ratio at Primary Level",
      "Net Enrolment Ratio at Upper Primary Level",
      "Out of schools",
      "Schools Constituted SMC(Government & Aided Schools) (%)",
      "Schools Providing Mid-Day Meal (Government & Aided Schools) (%)",
      "Schools that are Approachable by All Weather Road (%)",
      "Schools with Boys' Toilet (%)",
      "Schools with Computer (%)",
      "Schools with Drinking Water facility (%)",
      "Schools with Electricity (%)",
      "Schools with Girls' Toilet (%)",
      "Schools with Playground Facility (%)",
      "Single Classroom Schools (%)",
      "Single Teacher Schools (%)",
      "Students in std. V who can read std. II level paragraph (%)",
      "Total Female Teachers by School (%)",
      "Total Girls Enrolment (%)",
      "Total Literacy Rate",
      "Total Pupil-Teacher Ratio",
      "Total Regular Teachers with Professional Qualification(%)",
      "Women who are literate (%)",
      "Women with 10 or more years of schooling (%)",
      "Youth Literacy rate (Aged 15-24)",
    ],
  },
  {
    id: "health",
    name: "Health",
    icon: "🏥",
    color: "bg-red-500",
    description: "Health indicators and medical services",
    indicators: [
      "Abortion performed by skilled health personnel (%)",
      "Abortion taking place in Institution (%)",
      "All women who received Postnatal Check-up within 48 hrs. of delivery (%)",
      "Average Month of pregnancy at the time of abortion",
      "Average out of pocket expenditure per delivery in public health facility (Rs.)",
      "Births assisted by a doctor/nurse/LHV/ANM/other health personnel (%)",
      "Births delivered by caesarean section (%)",
      "Births in a private health facility delivered by caesarean section (%)",
      "Births in a public health facility delivered by caesarean section (%)",
      "Blood sugar level - high (>140 mg/dl) (%)",
      "Blood sugar level - very high (>160 mg/dl) (%)",
      "Caesarean out of total delivery taken place in Government Institutions (%)",
      "Caesarean out of total delivery taken place in Private Institutions (%)",
      "Children (aged 6-35 months) who received IFA tablets/syrup during last 3 months (%)",
      "Children (aged 6-35 months) who received at least one Vitamin A dose during last six months (%)",
      "Children age 12-23 months fully immunized (BCG, measles, and 3 doses each of polio and DPT) (%)",
      "Children age 12-23 months who have received 3 doses of DPT vaccine (%)",
      "Children age 12-23 months who have received 3 doses of Hepatitis B vaccine (%)",
      "Children age 12-23 months who have received 3 doses of polio vaccine (%)",
      "Children age 12-23 months who have received BCG (%)",
      "Children age 12-23 months who have received measles vaccine (%)",
      "Children age 12-23 months who received most of the vaccinations in private health facility (%)",
      "Children age 12-23 months who received most of the vaccinations in public health facility (%)",
      "Children age 9-59 months who received a vitamin A dose in last 6 months (%)",
      "Children aged 12-23 months Fully Immunized (%)",
      "Children aged 12-23 months having Immunization Card (%)",
      "Children aged 12-23 months received vaccination  from Anganwadi centre (%)",
      "Children aged 12-23 months received vaccination from Government health facility (%)",
      "Children aged 12-23 months received vaccination from Private health facility (%)",
      "Children aged 12-23 months who have received 3 doses of DPT (%)",
      "Children aged 12-23 months who have received 3 doses of Polio vaccine (%)",
      "Children aged 12-23 months who have received BCG (%)",
      "Children aged 12-23 months who have received Measles vaccine (%)",
      "Children born at home who were taken to a health facility for check-up within 24 hours of birth (%)",
      "Children suffering from Acute Respiratory Infection (%)",
      "Children suffering from Acute Respiratory Infection who sought treatment (%)",
      "Children suffering from Diarrhoea (%)",
      "Children suffering from Diarrhoea who received HAF/ORS/ORT & Zinc (%)",
      "Children suffering from Fever (%)",
      "Children suffering from Fever who sought treatment (%)",
      "Children under age 5 years whose birth was registered (%)",
      "Children who did not receive any vaccination (%)",
      "Children who have received Polio dose at birth (%)",
      "Children who received a health check after birth from a doctor/nurse/LHV/ANM/ midwife/otherhealth personnel within 2 days of birth (%)",
      "Children whose birth weight was taken (%)",
      "Children with birth weight less than 2.5 Kg. (%)",
      "Children with diarrhoea in the last 2 weeks who received oral rehydration salts (ORS) (%)",
      "Children with diarrhoea in the last 2 weeks who received zinc (%)",
      "Current Family Planning Usage- Any Method (%)",
      "Current Family Planning Usage- Condom (%)",
      "Current Family Planning Usage- Female Sterilization (%)",
      "Current Family Planning Usage- IUD/PPIUD (%)",
      "Delivery at Home (%)",
      "Delivery at home conducted by skilled health personnel (%)",
      "Having any kind of Symptoms of Chronic Illness (Per 100,000 Population)",
      "Having diagnosed for any kind of Chronic Illness and getting Regular Treatment (%)",
      "Households with any usual member covered by a health scheme or health insurance (%)",
      "Maternal Mortality Ratio",
      "Modern Contraceptive Prevalence Rate (mCPR)",
      "New borns who were checked up within 24 hrs. of birth (%)",
      "Persons diagnosed with Arthritis (Per 100,000 Population)",
      "Persons diagnosed with Asthma / Chronic Respiratory Disease (Per 100,000 Population)",
      "Persons diagnosed with Diabetes (Per 100,000 Population)",
      "Persons diagnosed with Hypertension (Per 100,000 Population)",
      "Persons diagnosed with Tuberculosis (TB)(Per 100,000 Population)",
      "Persons suffering from Acute Illness and taking treatment from Any Source (%)",
      "Persons suffering from Acute Illness and taking treatment from Government Source (%)",
      "Persons suffering from Acute Respiratory Infection (ARI)  (Per 100,000 Population)",
      "Persons suffering from Any type of Acute Illness (Per 100,000 Population)",
      "Persons suffering from Fever (Per 100,000 Population)",
      "Persons suffering from diarrhoea/dysentry (Per 100,000 Population)",
      "Safe Delivery (%)",
      "Total Unmet need (%)",
      "Total unmet need for Family Planning (%)",
      "Women Who have comprehensive knowledge of HIV/AIDS (%)",
      "Women age 15-19 years who were already mothers or pregnant at the time of the survey (%)",
      "Women aged 15-19 years who were already mothers or pregnant at the time of survey (%)",
      "Women availed benefit  from national programme for safe motherhood-Janani Shishu Suraksha Karyakrama (JSSK) (%)",
      "Women availed benefit  from national programme for safe motherhood-Janani Suraksha Yojana (JSY) (%)",
      "Women received first ANC in first trimester (%)",
      "Women received four or more ANCs (%)",
      "Women received/purchased 100 or more IFA tablets /syrup during pregnancy (%)",
      "Women who Delivered by skilled health provider (%)",
      "Women who consumed iron folic acid for 100 days or more when they were pregnant (%)",
      "Women who delivered at Public health facilities (%)",
      "Women who delivered at any health facility (%)",
      "Women who delivery at Government Institution (%)",
      "Women who delivery at Private Institution (%)",
      "Women who had antenatal check-up in the first trimester (%)",
      "Women who had at least 4 antenatal care visits (%)",
      "Women who had full antenatal care (%)",
      "Women who received any antenatal check-up during their last pregnancy (%)",
      "Women who received full ANC (%)",
      "Women who received postnatal care from a doctor/nurse/LHV/ANM/midwife/other health personnel within 2 days of delivery (%)",
      "Women who received postnatal check-up within 48 hrs. of delivery (%)",
      "Women who received post-natal Check-up within 1 week of delivery (%)",
      "Women with two children wanting no more children (%)",
      // NFHS-5 specific indicators (2019-21)
      "Average out-of-pocket expenditure per delivery in a public health facility (Rs.)",
      "Births attended by skilled health personnel10 (%)",
      "Births in a private health facility that were delivered by caesarean section (%)",
      "Births in a public health facility that were delivered by caesarean section (%)",
      "Children age 12-23 months fully vaccinated based on information from either vaccination card or mother's recall11 (%)",
      "Children age 12-23 months fully vaccinated based on information from vaccination card only12 (%)",
      "Children age 12-23 months who have received 3 doses of penta or DPT vaccine (%)",
      "Children age 12-23 months who have received 3 doses of penta or hepatitis B vaccine (%)",
      "Children age 12-23 months who have received 3 doses of polio vaccine13 (%)",
      "Children age 12-23 months who have received 3 doses of rotavirus vaccine14 (%)",
      "Children age 12-23 months who have received the first dose of measles-containing vaccine (MCV) (%)",
      "Children age 12-23 months who received most of their vaccinations in a private health facility (%)",
      "Children age 12-23 months who received most of their vaccinations in a public health facility (%)",
      "Children age 24-35 months who have received a second dose of measles-containing vaccine (MCV) (%)",
      "Children age 9-35 months who received a vitamin A dose in the last 6 months (%)",
      "Children born at home who were taken to a health facility for a check-up within 24 hours of birth (%)",
      "Children who received postnatal care from a doctor/nurse/LHV/ANM/midwife/other health personnel within 2 days of delivery (%)",
      "Children with diarrhoea in the 2 weeks preceding the survey who received oral rehydration salts (ORS) (%)",
      "Children with diarrhoea in the 2 weeks preceding the survey who received zinc (%)",
      "Children with diarrhoea in the 2 weeks preceding the survey taken to a health facility or health provider (%)",
      "Children with fever or symptoms of ARI in the 2 weeks preceding the survey taken to a health facility or health provider (%)",
      "Home births that were conducted by skilled health personnel10 (%)",
      "Households with any usual member covered under a health insurance/financing scheme (%)",
      "Institutional births (%)",
      "Institutional births in public facility (%)",
      "Mothers who consumed iron folic acid for 100 days or more when they were pregnant (%)",
      "Mothers who consumed iron folic acid for 180 days or more when they were pregnant (%)",
      "Mothers who had an antenatal check-up in the first trimester (%)",
      "Mothers who had at least 4 antenatal care visits (%)",
      "Mothers who received postnatal care from a doctor/nurse/LHV/ANM/midwife/other health personnel within 2 days of delivery (%)",
      "Mothers whose last birth was protected against neonatal tetanus9 (%)",
      "Prevalence of diarrhoea in the 2 weeks preceding the survey (%)",
      "Prevalence of symptoms of acute respiratory infection (ARI) in the 2 weeks preceding the survey (%)",
      "Registered pregnancies for which the mother received a Mother and Child Protection (MCP) card (%)",
      "Any method6 (%)",
      "Any modern method6 (%)",
      "Condom (%)",
      "Female sterilization (%)",
      "IUD/PPIUD (%)",
      "Injectables (%)",
      "Male sterilization (%)",
      "Pill (%)",
      "Total unmet need7 (%)",
      "Unmet need for spacing7 (%)",
      "Current users ever told about side effects of current method8 (%)",
      "Health worker ever talked to female non-users about family planning (%)",
      "Blood sugar level - high (141-160 mg/dl)23 (%)",
      "Blood sugar level - very high (>160 mg/dl)23 (%)",
      "Blood sugar level - high or very high (>140 mg/dl) or taking medicine to control blood sugar level23 (%)",
      "Mildly elevated blood pressure (Systolic 140-159 mm of Hg and/or Diastolic 90-99 mm of Hg) (%)",
      "Moderately or severely elevated blood pressure (Systolic ≥160mm of Hg and/or Diastolic ≥100mm of Hg) (%)",
      "Elevated blood pressure (Systolic ≥140 mm of Hg and/or Diastolic ≥90 mm of Hg) or taking medicine to control blood pressure (%)",
      "Ever undergone a screening test for cervical cancer (%)",
      "Ever undergone a breast examination for breast cancer (%)",
      "Ever undergone an oral cavity examination for oral cancer (%)",
      "Men age 15 years and above who use any kind of tobacco (%)",
      "Men age 15 years and above who consume alcohol (%)",
      "Women age 15 years and above who use any kind of tobacco (%)",
      "Women age 15 years and above who consume alcohol (%)",
    ],
  },
  {
    id: "wash",
    name: "WASH",
    icon: "💧",
    color: "bg-cyan-500",
    description: "Water, Sanitation and Hygiene",
    indicators: [
      "Households Without slab/open pit (%)",
      "Households having access to any improved source of drinking water (%)",
      "Households having access using improved sanitation facility (%)",
      "Households having bathing facility within the premises with Enclosure without roof (%)",
      "Households having toilet facility within the premises (%)",
      "Households not having toilet facility within the premises (%)",
      "Households practicing open defecation (%)",
      "Households with Flush/pour flush toilet connected to Piped sewer system (%)",
      "Households with Flush/pour flush toilet connected to Septic tank (%)",
      "Households with No drainage for Waste water outlet (%)",
      "Households with Waste water outlet connected to Closed drainage (%)",
      "Households with Waste water outlet connected to Open drainage (%)",
      "Households with bathrooms within the premises (%)",
      "Households with main source of drinking water from Covered well (%)",
      "Households with main source of drinking water from Handpump (%)",
      "Households with main source of drinking water from Tapwater from treated source (%)",
      "Households with main source of drinking water from Tubewell/Borehole (%)",
      "Households with no bathing facilites within the premises (%)",
      "Households with source of drinking water Away from household (%)",
      "Households with source of drinking water Near premises (%)",
      "Households with source of drinking water Within premises (%)",
      "Women aged 15-24 years who use hygeinic methods of protection during their menstrual period (%)",
      // NFHS-5 specific indicators (2019-21)
      "Population living in households that use an improved sanitation facility2 (%)",
      "Population living in households with an improved drinking-water source1 (%)",
      "Population living in households with electricity (%)",
      "Households using clean fuel for cooking3 (%)",
      "Households using iodized salt (%)",
      "Women age 15-24 years who use hygienic methods of protection during their menstrual period5 (%)",
    ],
  },
  {
    id: "energy",
    name: "Energy",
    icon: "⚡",
    color: "bg-amber-500",
    description: "Energy usage and electricity access",
    indicators: [
      "Households use Coal,Lignite,Charcoal for cooking fuel (%)",
      "Households use Cowdung cake for cooking fuel (%)",
      "Households use Crop residue  for cooking fuel (%)",
      "Households use Fire-wood for cooking fuel (%)",
      "Households use Kerosene for cooking fuel (%)",
      "Households use LPG/PNG for cooking fuel (%)",
      "Households use biogas for cooking fuel (%)",
      "Households using clean fuel for cooking (%)",
      "Households using electricity as the main source of lighting (%)",
      "Households using solar energy as main source of lighting (%)",
      "Households with No lighting (%)",
      "Households with electricity (%)",
      "Households with main source of lighting from Electricity (%)",
      "Households with main source of lighting from Kerosene (%)",
      "Households with main source of lighting from Solar energy (%)",
    ],
  },
  {
    id: "gender",
    name: "Gender",
    icon: "👥",
    color: "bg-fuchsia-500",
    description: "Gender equality and women empowerment",
    indicators: [
      "Currently married women who usually participate in households decisions (%)",
      "Ever married women who have ever experienced spousal violence (%)",
      "Ever married women who have experienced violence during any pregnancy (%)",
      "Female headed households (%)",
      "Percentage of females who got married < 18 years",
      "Women having a bank or savings account that they use themselves (%)",
      "Women having a mobile phone that they themselves use (%)",
      "Women owning a house and/or land (alone or jointly with others) (%)",
      "Women who got married before 18 years of age (%)",
    ],
  },
  {
    id: "livelihoods",
    name: "Livelihoods",
    icon: "💼",
    color: "bg-emerald-500",
    description: "Employment and economic activities",
    indicators: [
      "Children aged 5-14 years engaged in work (%)",
      "Children aged 5-14 years engaged in work (%)-Female",
      "Children aged 5-14 years engaged in work (%)-Male",
      "Female Labour force participation rate",
      "Male Labour force participation rate",
      "Total Labour force participation rate",
      "Women who worked in the last 12 months who were paid in cash (%)",
      "Work Participation Rate (15 years and above)",
      "Work Participation Rate (15 years and above)-Female",
      "Work Participation Rate (15 years and above)-Male",
    ],
  },
  {
    id: "people",
    name: "People",
    icon: "👨‍👩‍👧‍👦",
    color: "bg-indigo-500",
    description: "Demographics and population characteristics",
    indicators: [
      "Adolescent girls ever married at  aged 15-19 (%)",
      "Adolescent girls ever married at age 10-19 (%)",
      "Average HH size - All",
      "Average HH size - SC",
      "Average HH size - ST",
      "Birth Registered (%)",
      "Children aged below 5 years whose birth is registered (%)",
      "Children whose birth was registered and received Birth Certificate (%)",
      "Crude Death Rate",
      "Crude Death Rate - Female",
      "Crude Death Rate - Male",
      "Currently Married Men aged 25-29 years married before legal age (21 years) (%)",
      "Dependency ratio",
      "Infant Mortality Rate",
      "Infant mortality rate - Female",
      "Infant mortality rate - Male",
      "Infant mortality rate - Total",
      "Married Women aged 20-24 years married before legal age (18 years) (%)",
      "Mean age at effective marriage- Female",
      "Mean age at marriage (Female)",
      "Mean age at marriage (Male)",
      "Men aged 25-29 years married before age 21 years (%)",
      "Natural Growth Rate",
      "Neo-natal Mortality Rate",
      "Neo-natal moratality rate",
      "No of Households",
      "Percentage of Schedule Castes Population",
      "Percentage of Schedule Tribes Population",
      "Percentage of population in 0-6 years of age",
      "Peri-natal Mortality Rate",
      "Population below age 15 years (%)",
      "Post Neo-natal Mortality Rate",
      "Schedule Castes Population (%)",
      "Schedule Tribes Population (%)",
      "Sex Ratio",
      "Sex Ratio (0-6 years)",
      "Sex Ratio at Birth",
      "Sex ratio at birth for children born in the last five years (females per 1,000 males)",
      "Still Birth",
      "Total Birth Rate",
      "Total Fertility Rate",
      "Total Fertility rate",
      "Under Five mortality rate",
      "Under Five mortality rate - Female",
      "Under Five mortality rate - Male",
      "Under Five mortality rate- Total",
      "Women aged 20-24 years married before age 18 years (%)",
      // NFHS-5 specific indicators (2019-21)
      "Female population age 6 years and above who ever attended school (%)",
      "Children under age 5 years whose birth was registered with the civil authority (%)",
      "Deaths in the last 3 years registered with the civil authority (%)",
      "Sex ratio of the total population (females per 1,000 males)",
      "Births in the 5 years preceding the survey that are third or higher order (%)",
      "Children age 5 years who attended pre-primary school during the school year 2019-20 (%)",
      "Women who are literate4 (%)",
      "Women with 10 or more years of schooling (%)",
      "Women age 20-24 years married before age 18 years (%)",
    ],
  },
  {
    id: "nutrition",
    name: "Nutrition",
    icon: "🍎",
    color: "bg-orange-500",
    description: "Nutritional status and food security",
    indicators: [
      "All women age 15-49 years who are anaemic (%)",
      "Breastfeeding children age 6-23 months receiving an adequate diet (%)",
      "Children (6 -23 months) fed a minimum number of times (%)",
      "Children (6 -23 months) fed had a minimum dietary diversity (%)",
      "Children (aged 6-35 months) exclusively breastfed for at least six months (%)",
      "Children age 6-59 months who are anaemic (<11.0 g/dl) (%)",
      "Children age 6-8 months receiving solid or semi-solid food and breastmilk (%)",
      "Children aged 0-23 months breastfed immediately/ within an hour of  birth (%)",
      "Children aged 0-59 months Severely stunted (Height for age below -3SD) (%)",
      "Children aged 0-59 months Stunted (Height for age below -2SD) (%)",
      "Children aged 0-59 months Underweight (Weight for age below -2SD) (%)",
      "Children aged 0-59 months Wasted (Weight for height below -2SD) (%)",
      "Children aged 36-71 months availing supplementary food from Anganwadi (%)",
      "Children aged 36-71 months beneficiaries of supplementry food (%)",
      "Children aged 6-35 months availing supplementary food from Anganwadi (%)",
      "Children aged 6-35 months beneficiaries of supplementry food (%)",
      "Children aged 6-35 months who received supplementary nutrition for 21 or more days in the month prior to survey (%)",
      "Children under 5 years who are severely wasted (weight-for-height) (%)",
      "Children under 5 years who are stunted (height-for-age) (%)",
      "Children under 5 years who are underweight (weight-for-age) (%)",
      "Children under 5 years who are wasted (weight-for-height) (%)",
      "Children under 6 months who are exclusively breastfed (%)",
      "Children under age 3 years breastfed within one hour of birth (%)",
      "Currently pregnant women aware of all Services at AWC (%)",
      "Currently pregnant women aware of supplementary food at AWC  (%)",
      "Households using adequately iodized salt (> =15 ppm) (%)",
      "Households using iodized salt (%)",
      "Lactating mothers availing supplementary food from Anganwadi (%)",
      "Lactating mothers beneficiaries of supplementry food (%)",
      "Lactating mothers who received supplementary nutrition for 21 or more days in the month prior to survey (%)",
      "Men age 15-49 years who are anaemic (<13.0 g/dl) (%)",
      "Men whose Body Mass Index (BMI) is below normal (BMI < 18.5 kg/m 2)(%)",
      "Mothers of children aged 0-35 months aware of Immunization at AWC (%)",
      "Mothers of children aged 0-35 months aware of health check-up at AWC (%)",
      "Mothers of children aged 0-35 months aware of nutrition and all Services at AWC (%)",
      "Mothers of children aged 0-35 months aware of supplementary food at AWC (%)",
      "Non-breastfeeding children age 6-23 months receiving an adequate diet (%)",
      "Non-pregnant women age 15-49 years who are anaemic (<12.0 g/dl) (%)",
      "Pregnant women aged 15-49 years who are anaemic (<11.0 g/dl) (%)",
      "Pregnant women availing supplementary food from Anganwadi (%)",
      "Pregnant women beneficiaries of supplementry food (%)",
      "Pregnant women who received supplementary nutrition for 21 or more days in the month prior to survey (%)",
      "Total children age 6-23 months receiving an adequate diet (%)",
      "Women aged 15-49 years whose Body Mass Index (BMI) is below normal (< 18.5 kg/m2) (%)",
      "AWCs conducted sixteen or more days PSE sessions in one calendar month prior to survey (%)",
      // NFHS-5 specific indicators (2019-21)
      "Children age 6-59 months who are anaemic (<11.0 g/dl)22 (%)",
      "Children age 6-8 months receiving solid or semi-solid food and breastmilk16 (%)",
      "Children under 5 years who are overweight (weight-for-height)20 (%)",
      "Children under 5 years who are severely wasted (weight-for-height)19 (%)",
      "Children under 5 years who are stunted (height-for-age)18 (%)",
      "Children under 5 years who are underweight (weight-for-age)18 (%)",
      "Children under 5 years who are wasted (weight-for-height)18 (%)",
      "Children under age 3 years breastfed within one hour of birth15 (%)",
      "Children under age 6 months exclusively breastfed16 (%)",
      "Breastfeeding children age 6-23 months receiving an adequate diet16, 17 (%)",
      "Non-breastfeeding children age 6-23 months receiving an adequate diet16, 17 (%)",
      "Total children age 6-23 months receiving an adequate diet16, 17 (%)",
      "All women age 15-19 years who are anaemic22 (%)",
      "All women age 15-49 years who are anaemic22 (%)",
      "Non-pregnant women age 15-49 years who are anaemic (<12.0 g/dl)22 (%)",
      "Pregnant women age 15-49 years who are anaemic (<11.0 g/dl)22 (%)",
      "Women whose Body Mass Index (BMI) is below normal (BMI <18.5 kg/m2)21 (%)",
      "Women who are overweight or obese (BMI ≥25.0 kg/m2)21 (%)",
      "Women who have high risk waist-to-hip ratio (≥0.85) (%)",
    ],
  },
  {
    id: "climate",
    name: "Climate",
    icon: "🌡️",
    color: "bg-teal-500",
    description: "Climate and environmental indicators",
    indicators: [
      "Average Temperature (°C)",
      "Annual Mean Maximum Temperature (°C)",
      "Annual Mean Minimum Temperature (°C)",
      "Forest Cover (%)",
      "Air Quality Index (AQI)",
      "Annual Rainfall (mm)",
      "Monsoon Rainfall (mm)",
      "Winter Rainfall (mm)",
      "Pre-Monsoon Rainfall (mm)",
      "Post-Monsoon Rainfall (mm)",
    ],
  },
  {
    id: "government-schemes",
    name: "Government schemes",
    icon: "🏛️",
    color: "bg-amber-600",
    description: "Programme and scheme-linked indicators (coming soon)",
    indicators: [],
  },
];

export const geographyOptions = [
  { value: "india", label: "All India" },
  { value: "andaman-nicobar", label: "Andaman & Nicobar Islands" },
  { value: "andhra-pradesh", label: "Andhra Pradesh" },
  { value: "arunachal-pradesh", label: "Arunachal Pradesh" },
  { value: "assam", label: "Assam" },
  { value: "bihar", label: "Bihar" },
  { value: "chandigarh", label: "Chandigarh" },
  { value: "chhattisgarh", label: "Chhattisgarh" },
  { value: "dadra-nagar-haveli", label: "Dadra & Nagar Haveli" },
  {
    value: "dadra-nagar-haveli-daman-diu",
    label: "Dadra & NH and Daman & Diu",
  },
  { value: "daman-diu", label: "Daman & Diu" },
  { value: "delhi", label: "Delhi" },
  { value: "goa", label: "Goa" },
  { value: "gujarat", label: "Gujarat" },
  { value: "haryana", label: "Haryana" },
  { value: "himachal-pradesh", label: "Himachal Pradesh" },
  { value: "jammu-kashmir", label: "Jammu & Kashmir" },
  { value: "ladakh", label: "Ladakh" },
  { value: "jharkhand", label: "Jharkhand" },
  { value: "karnataka", label: "Karnataka" },
  { value: "kerala", label: "Kerala" },
  { value: "lakshadweep", label: "Lakshadweep" },
  { value: "madhya-pradesh", label: "Madhya Pradesh" },
  { value: "maharashtra", label: "Maharashtra" },
  { value: "manipur", label: "Manipur" },
  { value: "meghalaya", label: "Meghalaya" },
  { value: "mizoram", label: "Mizoram" },
  { value: "nagaland", label: "Nagaland" },
  { value: "odisha", label: "Odisha" },
  { value: "puducherry", label: "Puducherry" },
  { value: "punjab", label: "Punjab" },
  { value: "rajasthan", label: "Rajasthan" },
  { value: "sikkim", label: "Sikkim" },
  { value: "tamil-nadu", label: "Tamil Nadu" },
  { value: "telangana", label: "Telangana" },
  { value: "tripura", label: "Tripura" },
  { value: "uttar-pradesh", label: "Uttar Pradesh" },
  { value: "uttarakhand", label: "Uttarakhand" },
  { value: "west-bengal", label: "West Bengal" },
];

export const residenceOptions = [
  { value: "total", label: "Total" },
  { value: "rural", label: "Rural" },
  { value: "urban", label: "Urban" },
];

// Source options with their available years (consolidated by source name)
export const sourceOptions = [
  {
    value: "NFHS",
    label: "NFHS",
    years: ["2019-21", "2015-16"],
  },
  {
    value: "AHS",
    label: "AHS",
    years: ["2012-13", "2011-12"],
  },
  {
    value: "CENSUS",
    label: "Census",
    years: ["2011"],
  },
  {
    value: "RSOC",
    label: "RSOC",
    years: ["2014"],
  },
  {
    value: "DISE",
    label: "DISE",
    years: ["2014-15", "2013-14"],
  },
  {
    value: "SRS",
    label: "SRS",
    years: ["2014", "2013", "2007-09"],
  },
  {
    value: "ASER",
    label: "ASER",
    years: ["2015", "2014"],
  },
  {
    value: "CLIMATE",
    label: "Climate Data",
    years: ["1943-2012"],
  },
  {
    value: "IMD",
    label: "India Meteorological Department",
    years: ["1951-2000"],
  },
  {
    value: "NOAA/PSL",
    label: "NOAA/PSL",
    years: ["2025", "2026", "1991-2020"],
  },
];

// View modes available
export const viewModes = [
  { id: "map", label: "Map", description: "Geographic visualization" },
  { id: "compare", label: "Compare", description: "State comparison" },
  { id: "table", label: "Table", description: "Detailed data table" },
];
